<template>
<main class="content-wrapper">
  <sidebar-modal :active.sync="sidebarActive"
    v-on:action="sidebarAction" v-on:destroy="sidebarDestroy"
    :title="sidebarTitle"
    :button="sidebarButton" :destructive="destructiveButton"
    :loading="sidebarLoading" :buttonEnabled="!sidebarLoading">
    <banner :active.sync="bannerActive" :title="bannerTitle" :error="bannerError" :time=2000 />
    <component :cvError="cvError"  :is="sidebarComponent" />
  </sidebar-modal>
  <dropdown-modal :active.sync="confirmationActive" :title="confirmationTitle" :autoClip="false">
    <p class=modal-text>{{confirmationText}}</p>
    <div class="modal-buttons">
      <button class="button is-primary" @click="confirmAction">{{this.$t('common.yes')}}</button>
      <button class="button is-danger" @click="cancelAction">{{this.$t('common.no')}}</button>
    </div>
  </dropdown-modal>
  <dropdown-modal title="Choose An Option" :active.sync="deleterefferal.confirmation" :autoClip="false">
    <referral-remove-modal :itemindex="deleterefferal.itemindex" :userid="deleterefferal.userid" />
  </dropdown-modal>

  <div v-if="currentJob">
    <div class="columns">
      <div class="column is-two-thirds">
        <job-details-card :job="currentJob" class="details-card"/>
        <job-description-card :job="currentJob"/>
        <div class="job-meta p-t-40" v-if="currentJob.tags && currentJob.tags.length > 0 && !isWidget">
          <h3 class="title">Tags</h3>
          <job-tags  :tags="currentJob.tags" />
        </div>
      </div>
      <div class="column">
        <job-action-card :widget="isWidget" class="is-fixed" :job="currentJob"
        :appliedCounts="appliedCounts"
        v-on:apply="apply" v-on:refer="refer" v-on:accepted="accepted"
        v-on:viewApplication="viewApplication"  v-on:viewOffer="viewOffer" />
      </div>
    </div>
  </div>
</main>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import JobDetailsCard from '../components/jobs/job-details-card'
import ReferPage from '@/components/jobs/jobs-refer-page'
import JobDescriptionCard from '../components/jobs/job-description-card.vue'
import JobActionCard from '../components/jobs/job-action-card'
import ApplyForm from '@/components/jobs/apply-form'
import ApplicationPage from '@/components/jobs/application-page'
import OfferPage from '@/components/jobs/offer-page'
import Confirmation from '@/components/jobs/apply-confirmation'
import ReferConfirmation from '@/components/jobs/referral-confirmation'
import SidebarModal from '@/components/sidebar-modal'
import Banner from '@/components/general/banner'
import Container from '@/components/general/container'
import DropdownModal from '@/components/dropdown-modal'
import ReferralRemoveModal from '@/components/referrals/referral-remove-modal'
import JobTags from '@/components/jobs/job-tags'

export default {
  components: {
    JobDetailsCard,
    JobDescriptionCard,
    JobActionCard,
    ApplyForm,
    ApplicationPage,
    OfferPage,
    SidebarModal,
    Banner,
    Confirmation,
    ReferPage,
    ReferConfirmation,
    Container,
    DropdownModal,
    ReferralRemoveModal,
    JobTags
  },
  computed: {
    ...mapGetters('jobs', [
      'currentJob',
      'currentApplication',
      'currentOffer'
    ]),
    ...mapGetters('applicationForm', [
      'returnedApplication'
    ]),
    ...mapGetters('jobseekerProfiles', [
      'resumeStatus'
    ]),
    ...mapState('jobReferral', {
      selectedReferrals: 'selected',
      deleterefferal: 'deleterefferal'
    }),
    ...mapGetters('users', ['user']),
    jobId () {
      return this.$route.params.id
    },
    appliedCounts () {
      return this.currentJob.applications
    },
    isWidget () {
      return !!this.$route.meta.hasOwnProperty('widgetMode')
    }
  },
  watch: {
    resumeStatus (newVal, oldVal) {
      if (newVal === 'Attached' && this.sidebarComponent === 'ApplyForm') {
        this.sidebarButton = this.$t('jobs.submitApplication')
        this.cvError = null
      } else {
        this.sidebarButton = null
      }
    }
  },
  methods: {
    ...mapActions('adminApplications', {
      getAllApplications: 'getAll'
    }),
    ...mapActions('jobs', [
      'getJob',
      'getJobUpdate',
      'getApplication',
      'setApplication',
      'deleteApplication',
      'jobViewed',
      'getOffer',
      'rejectOffer',
      'acceptOffer'
    ]),
    ...mapMutations('jobs', [
      'resetCurrentJob',
      'resetJobs'
    ]),
    ...mapMutations('applicationForm', {
      setApplicationJobId: 'setJobId',
      setCoverLetter: 'setCoverLetter',
      clearApplication: 'clear'
    }),
    ...mapMutations('jobReferral', {
      setReferralJob: 'setJob',
      setReferralSelections: 'setSelected',
      setReferralSuggestions: 'setSuggestions'
    }),
    ...mapActions('jobReferral', [
      'submitReferrals'
    ]),
    ...mapActions('applicationForm', {
      submitApplication: 'apply'
    }),
    apply () {
      if (this.isWidget) {
        window.open(`${window.location.origin}/jobs/${this.currentJob.id}`, '_blank')
      } else {
        if (!this.user) {
          this.$router.push({path: `/signup/`})
          return
        }
        this.sidebarLoading = false
        this.sidebarTitle = this.$t('jobs.apply')
        this.sidebarComponent = 'ApplyForm'
        this.sidebarButton = this.$t('jobs.submitApplication')
        this.destructiveButton = null
        this.sidebarActive = true
      }
    },
    refer () {
      if (this.isWidget) {
        window.open(`${window.location.origin}/jobs/${this.currentJob.id}`, '_blank')
      } else {
        if (!this.user) {
          this.$router.push({path: `/signup/`})
          return
        }
        this.sidebarLoading = false
        this.sidebarTitle = this.$t('jobs.referSomebody')
        this.sidebarComponent = 'ReferPage'
        this.sidebarButton = this.$t('jobs.submitReferral')
        this.destructiveButton = null
        this.setReferralJob(this.currentJob)
        this.setReferralSelections([])
        this.setReferralSuggestions([])
        this.sidebarActive = true
      }
    },
    viewApplication () {
      this.sidebarLoading = false
      this.destructiveButton = 'Cancel Application'
      if (this.currentApplication.status === 'pending') {
        this.sidebarTitle = this.$t('jobs.applied')
      } else if (this.currentApplication.status === 'interviewing') {
        this.sidebarTitle = this.$t('jobs.interviewing')
      } else if (this.currentApplication.status === 'rejected') {
        this.sidebarTitle = this.$t('jobs.rejected')
        this.destructiveButton = null
      } else {
        this.sidebarTitle = this.$t('jobs.applicationDetails') // Should never happen but good to have a default
      }
      this.sidebarComponent = 'ApplicationPage'
      this.sidebarActive = true
    },
    viewOffer () {
      this.sidebarLoading = false
      this.sidebarTitle = this.$t('jobs.offerDetails')
      this.sidebarComponent = 'OfferPage'
      this.sidebarButton = this.$t('jobs.accept')
      this.destructiveButton = this.$t('jobs.reject')
      this.sidebarActive = true
    },
    accepted () {
      this.sidebarLoading = false
      this.sidebarTitle = this.$t('jobs.offerDetails')
      this.sidebarComponent = 'OfferPage'
      this.sidebarButton = null
      this.destructiveButton = null
      this.sidebarActive = true
    },
    cancelAction () {
      this.confirmationActive = false
    },
    async confirmAction () {
      this.confirmationActive = false
      switch (this.sidebarComponent) {
        case 'ApplicationPage': {
          this.deleteApplication(this.jobId).then(
            this.getJobUpdate(this.jobId)
          )
          this.sidebarActive = false
          break
        }
        case 'OfferPage': {
          this.sidebarLoading = true
          if (!this.deletionConfirmation) {
            await this.acceptOffer(this.currentOffer.id)
            this.bannerTitle = this.$t('jobs.jobOfferAccepted')
            this.bannerActive = true
          } else if (this.deletionConfirmation) {
            await this.rejectOffer(this.currentOffer.id)
            this.bannerTitle = this.$t('jobs.jobOfferRejected')
            this.bannerActive = true
            this.bannerError = true
          }
          this.sidebarLoading = false
          this.getJob(this.jobId)
          const self = this
          setTimeout(function () {
            self.bannerTitle = ''
            self.bannerActive = false
            self.bannerError = false
            self.sidebarActive = false
          }, 2050)
          break
        }
        default: {
          break
        }
      }
    },
    resetBannerError () {
      this.bannerError = null
    },
    async sidebarAction () {
      switch (this.sidebarComponent) {
        case 'ApplyForm': {
          if (this.resumeStatus === 'Unattached') {
            this.bannerActive = true
            this.bannerError = this.$t('jobs.attachCv')
            this.cvError = 'Required'
            return false
          }
          this.resetBannerError()
          this.$ga.event('Job', 'Apply Clicked', 'id', this.currentJob.id)
          this.$intercom.update({completed_job_application: true})
          this.sidebarLoading = true
          await this.submitApplication()
          this.sidebarLoading = false
          this.sidebarTitle = this.$t('jobs.applied')
          this.sidebarComponent = 'Confirmation'
          this.bannerTitle = this.$t('jobs.applicationSubmitted')
          this.bannerActive = true
          this.sidebarButton = null
          this.resetCurrentJob(null)
          this.getJobUpdate(this.jobId)
          this.setApplication(this.returnedApplication)
          break
        }
        case 'ReferPage': {
          if (this.selectedReferrals.length === 0) { return }
          this.$ga.event('Job', 'Referral Clicked', 'id', this.currentJob.id)
          this.sidebarLoading = true
          try {
            await this.submitReferrals()
            this.$intercom.update({completed_job_referral: true})
            this.sidebarTitle = this.$t('jobs.referralSuccessful')
            this.sidebarComponent = 'ReferConfirmation'
            this.sidebarButton = null
            this.bannerTitle = this.$t('jobs.referralsSubmitted')
            this.bannerActive = true
          } catch (error) {
            console.log(error)
            this.sidebarActive = false
          }
          this.sidebarLoading = false
          break
        }
        case 'ApplicationPage': {
          break
        }
        case 'OfferPage': {
          this.deletionConfirmation = false
          this.confirmationActive = true
          this.confirmationTitle = this.$t('jobs.areYouSure')
          this.confirmationText = this.$t('jobs.confirmTextForOfferAccept')
          break
        }
        default: {
          break
        }
      }
    },
    async sidebarDestroy () {
      switch (this.sidebarComponent) {
        case 'ApplyForm': {
          break
        }
        case 'ReferPage': {
          break
        }
        case 'ApplicationPage': {
          this.deletionConfirmation = true
          this.confirmationActive = true
          this.confirmationTitle = this.$t('jobs.areYouSure')
          this.confirmationText = this.$t('jobs.confirmTextForDelete')
          break
        }
        case 'OfferPage': {
          this.deletionConfirmation = true
          this.confirmationActive = true
          this.confirmationTitle = this.$t('jobs.areYouSure')
          this.confirmationText = this.$t('jobs.confirmTextForOfferDecline')
          break
        }
        default: {
          break
        }
      }
    }
  },
  async mounted () {
    await this.getJob(this.jobId)
    this.getOffer(this.jobId)
    this.getApplication(this.jobId)
    this.$store.dispatch('jobseekerProfiles/getJobseekerProfile')
    this.jobViewed(this.jobId)
    this.clearApplication()
    this.setApplicationJobId(this.jobId)
  },
  beforeDestroy () {
    this.resetCurrentJob(null)
  },
  data () {
    return {
      sidebarActive: false,
      sidebarTitle: '',
      sidebarComponent: '',
      sidebarLoading: false,
      bannerActive: false,
      sidebarButton: null,
      destructiveButton: null,
      bannerTitle: 'Application Submitted',
      confirmationActive: false,
      confirmationTitle: null,
      confirmationText: null,
      deletionConfirmation: false,
      bannerError: false,
      cvError: null
    }
  }
}
</script>

<style lang="scss" scoped>
.details-card {
  margin-bottom: 1rem;
}
.modal-text {
  line-height: 1.5em;
}
div.modal-buttons {
  display: flex;
  flex-grow: 1;
  .button {
    flex-grow: 1;
    margin-right: 1rem;
    &:last-child {
      margin-right: 0;
    }
  }
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/pages/job.vue